import React from "react";
import { GROUP_META, STATUS_META } from "../lib/format";

export function StatusBadge({ status, className = "" }) {
  const meta = STATUS_META[status] || { label: status, group: "creado" };
  const g = GROUP_META[meta.group];
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${g.pill} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: g.dot }} />
      {meta.label}
    </span>
  );
}
